import vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import './assets/iconfont/iconfont.js'
import plugins from './components/index';
// import fieldoptions from './components/fieldOptions';
// import query from './components/query';
//import formDesigner from './index'
import router from '@/router'

vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.prototype.$axios = axios
//Vue.prototype.fieldoptions = fieldoptions
// Vue.prototype.query = query
vue.use(plugins);

var vue_ = new vue({
  router,
  data: function(){
	  return {
		  query: {},
		  
		  dataname: "",
		  fieldoptions: [],
		  fieldsobj: {},
	  }
  },
  render: h => h(App),
}).$mount('#app')

